import { FC, Suspense, useEffect } from 'react'
import Intercom from 'components/global/Intercom'
import { isEmpty } from 'lodash'
import { useSelector } from 'utils/hooks'
import { ORGANISATION_NAME } from 'env'
import { getCurrentUser, setAuthToken, validateCompany } from 'redux/authUser/actionCreators'
import { useDispatch } from 'react-redux'
import NavigationLoader from 'components/global/Loaders/NavigationLoader'
import LoaderComponent from 'components/LoaderComponent'
import AppNotifications from 'containers/authorised/AppNotifications'
import NewNavigation from 'components/NewNavigation'
import useQuery from 'components/global/hooks/useQuery'

// Routes
import AuthorisedRoutes from 'routes/authorised/AuthorisedRoutes'
import PublicRoutes from './public/authRoutes'

const RootRouter: FC = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector((s) => s.auth.employee)

  const { switchedAccount } = useQuery(true)

  const isNotCareersPage = !window.location.hash?.includes('#/careers')
  const isLogged = localStorage.getItem('LoggedIn')

  const validatorCall = async (): Promise<void> => {
    await dispatch(validateCompany({ company_name: ORGANISATION_NAME || '' }))
    dispatch(getCurrentUser())
  }

  useEffect(() => {
    if (switchedAccount) {
      let url = window.location.href
      if (!isLogged) {
        setAuthToken()
        window.location.reload()
      } else {
        url = url.replace('?switchedAccount=true', '')
        window.location.href = url
      }
    }
  }, [switchedAccount])

  useEffect(() => {
    if (isLogged && isNotCareersPage) validatorCall()
  }, [])

  return isLogged && isNotCareersPage ? (
    <>
      {isEmpty(currentUser) ? (
        <NavigationLoader />
      ) : (
        <NewNavigation>
          <Suspense fallback={<LoaderComponent />}>
            <AuthorisedRoutes />
          </Suspense>
        </NewNavigation>
      )}
      <Intercom />
      <AppNotifications />
    </>
  ) : (
    <PublicRoutes />
  )
}

export default RootRouter
